import { render, staticRenderFns } from "./ReferenceMenu.vue?vue&type=template&id=38afebdc&scoped=true&"
import script from "./ReferenceMenu.vue?vue&type=script&lang=js&"
export * from "./ReferenceMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38afebdc",
  null
  
)

export default component.exports